import { DELIVERY_PRICE_ADDITION } from "./marketPriceCds";

export const INITIAL_MARKET_PRICE_SETTING = {
    marketPriceName: "",
    isUsingSellingPrice: false,
    primePriceMarkUpRate: "",
    sellingPriceMarkUpRate: "",
    deliveryPriceAdditionCd: DELIVERY_PRICE_ADDITION.NONE,
    deliveryPriceAdditionAmount: "",
    unitPriceCd: 1,
    orderFormColumnCountDirectionCd: 1,
    orderFormProductTypePartitionCd: 1,
    orderFormDeadlineHourOutputCd: 1,
    orderFormOrderQuantityOutputCd: 1,
    orderDeadlineHour: 14,
    orderFormContactCd: 1,
    shippingDateInitialSettingCd: 1,
    orderFormShopSummaryCd: 1,
    destinationOutputCd: 1,
    usingShops: [{
        customerId: 0,
        shopId: 0,
    }]

};
